export const setOrigins = ({ commit }, payload) => {
  commit('SET_ORIGINS', payload)
}

export const setOriginsLoading = ({commit}, payload) => {
  commit('SET_ORIGINS_LOADING', payload)
}